import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { dripKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useDripStats = (dripId, params) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryKey: dripKeys.stats(dripId, params),
        queryFn: () => axios.get(markUrl('drips/stats/'), {
            ...additional,
            params: { drip_id: dripId, ...params }
        }),
        staleTime: 30_000,
        enabled: dripId > 0,
        refetchInterval: (query) => {
            const active = query.state.data?.data?.funnel?.active;
            return active != null && active > 0 ? 15_000 : false;
        }
    });
};
export default useDripStats;
